import { motion } from "framer-motion";
import { Breadcrumb } from "./Breadcrumb";

const HERO_INITIAL = { opacity: 0, y: 24 };
const HERO_ANIMATE = { opacity: 1, y: 0 };
const HERO_TRANSITION = { duration: 0.7, ease: [0.16, 1, 0.3, 1] };

export const PageHero = ({ eyebrow, h1, image, breadcrumbLabel }) => (
  <section className="relative h-[55vh] min-h-[440px] w-full overflow-hidden bg-twp-charcoal flex items-end">
    {image && <img src={image} alt={h1} className="absolute inset-0 h-full w-full object-cover brightness-[0.45]" />}
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />
    <motion.div
      initial={HERO_INITIAL}
      animate={HERO_ANIMATE}
      transition={HERO_TRANSITION}
      className="relative z-10 w-full px-6 md:px-16 pb-14"
    >
      <div className="max-w-4xl">
        <Breadcrumb current={breadcrumbLabel} />
        <span className="text-twp-gold text-xs uppercase tracking-[0.35em]">{eyebrow}</span>
        <h1 data-testid="page-h1" className="font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-white mt-4">
          {h1}
        </h1>
      </div>
    </motion.div>
  </section>
);
